// useTheme — light/dark переключатель с персистенцией в localStorage.
//
// Cross-tab sync через storage event (см. useLocalStorage).
// Ключ: "multitool:theme" — значения "light" | "dark".
import { useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";

export type ThemeMode = "light" | "dark";

export function useTheme() {
  const [mode, setMode] = useLocalStorage<ThemeMode>("theme", "light");

  const toggle = useCallback(() => {
    setMode(mode === "dark" ? "light" : "dark");
  }, [mode, setMode]);

  return { mode, setMode, toggle, isDark: mode === "dark" };
}
